import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";

import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./Unsubscribe.css";
import { Link } from "react-router-dom";


export default function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    document.title = "Kútonline - Leiratkozás";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    
    try {
      const res = await fetch(`${apiUrl}/newsletter/unsubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setStatus('error');
        setMessage(data.message || 'Hiba történt. ');
        return;
      }

      setStatus('success');
      setMessage(data.message || 'Sikeres leiratkozás.');

      setTimeout(() => {
        window.location.href = "/";
      }, 1500);
    } catch (err) {
      setStatus('error');
      setMessage(
        <span>
          Hiba történt.  <br />
          Kérjük keressen minket a <Link to="/contact">Kapcsolat</Link> menüpontnál és jelezze a Hírlevélről való leiratkozási szándékát. 
          <br />Köszönjük megértését!
        </span>
        

      );
    }
  };

  return (
    <div>
      <Navbar />
      <DarkModeButton />

      <div className="page-container">
        <h1>Leiratkozás a hírlevélről</h1>
        <p>Ha nem szeretnél több hírlevelet kapni tőlünk, itt leiratkozhatsz.</p>

        <form className="unsubscribe-form" onSubmit={handleSubmit}>
          <label htmlFor="email">E-mail cím:</label><br />
          <input
            type="email"
            id="email"
            name="email"
            maxLength={70}
            required
            placeholder="sajat@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          /><br /><br />
          <button type="submit" disabled={status === 'loading'}>
            {status === 'loading' ? 'Feldolgozás...' : 'Leiratkozom'}
          </button>
        </form>

        {status === 'success' && (
          <div className="alert-box success">
            {message}
          </div>
        )}
        {status === 'error' && (
          <div className="alert-box wrong_data">
            {message}
          </div>
        )}

        <Link className="unsubscribe-link" to="/">Vissza a főoldalra</Link>
      </div>


      <ScrollToTopButton />
    </div>
  );
}